import { Swiper, SwiperSlide } from "swiper/react";
import { Image, Modal, Typography, Space, Tooltip, Button } from 'antd';
import { Pagination, Navigation } from "swiper";
import { Key, useContext, useState, useEffect } from "react";
import { DeleteOutlined, LeftOutlined, RightOutlined, PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

// Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./swiper.css";

import { ButtonLZ } from "../Buttons/ButtonLZ";
import { authFetch } from "../../../../common/request/authFetch";
import { useIsAuthorized } from "../../../pages/common/roles/Roles";
import { useAuth } from "../../../../store/AuthContext/AuthContext";

const { Text } = Typography;

export default function PhotosSwiper({ mediaItems }: any) {
  const { t } = useTranslation();
  const isAuthorized = useIsAuthorized();
  const [images, setImages] = useState<any[]>(mediaItems);
  const { projectGroup } = useAuth();

  // Sincronizar estado local si mediaItems cambia desde el padre
  useEffect(() => {
    setImages(mediaItems);
  }, [mediaItems]);

  const deleteMedia = async (name: any) => {
    try {
      await authFetch(
        `${process.env.REACT_APP_API}/projects/${projectGroup.project}/${name}`,
        { method: 'DELETE' }
      );
      setImages(prev => prev.filter(item => item.name !== name));
    } catch (error) {
      console.error("Error deleting media", error);
    }
  };

  const canEdit = isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_INFO']);

  return (
    <div className="modern-swiper-container">
      
      <div className="swiper-wrapper-relative">
      <Swiper
        slidesPerView={3} 
        spaceBetween={15}      
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 10 },
          640: { slidesPerView: 2, spaceBetween: 15 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
        }}
        pagination={{ clickable: true }}
        navigation={{
          prevEl: '.prev-btn',
          nextEl: '.next-btn',
        }}
        modules={[Pagination, Navigation]}
        className="mySwiper"
      >
          {images.map((mediaItem: any, index: number) => (
            <SwiperSlide key={mediaItem.name || index}>
              <div className="slide-card">
                <Image
                  src={mediaItem.googleUrl}
                  preview={true}
                  className="main-img"
                  fallback="https://via.placeholder.com/400x300?text=No+Image"
                />
                
                {canEdit && (
                  <div className="delete-overlay">
                    <Tooltip title={t('dictionary.delete')}>
                      <Button
                        danger
                        shape="circle"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                          Modal.confirm({
                            title: t('locals.drawer.tabs.photo.delete.title'),
                            centered: true,
                            okText: t('dictionary.confirm'),
                            okButtonProps: { danger: true },
                            cancelText: t('dictionary.cancel'),
                            onOk: () => deleteMedia(mediaItem.name),
                          });
                        }}
                      />
                    </Tooltip>
                  </div>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Controles de navegación personalizados y minimalistas */}
        <button className="nav-btn prev-btn"><LeftOutlined /></button>
        <button className="nav-btn next-btn"><RightOutlined /></button>
      </div>
    </div>
  );
}